module.exports = __webpack_public_path__ + "static/media/jitu.ca20a500.png";